'use client'
import React, { useState } from 'react'
import Link from 'next/link';
import { FormInput } from "@/components/FormInput.jsx";
import { formValidation } from "@/helpers/formValiation.js";

const initialValues = {
    fullName: "",
    email: "",
    gender: "",
    mobile: "",
    registration: "",
    programme: "",
    category: "",
    message: "",
};

const grievanceCategories = [
    "Examination",
    "General Facility",
    "Results",
    "Fees",
    "Degree",
    "Notice",
    "Time Table",
    "Admission",
    "Caste Discrimination",
];

export const GrievanceRedressal = () => {

    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState({});
    const [submitting, setSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setValues((prev) => ({ ...prev, [name]: value }));
        setErrors((prev) => ({ ...prev, [name]: "" }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = formValidation(values);

        if (Object.keys(validationErrors).length) {
            setErrors(validationErrors);
            return;
        }

        try {
            setSubmitting(true);
            console.log("Form submitted successfully");
            setValues(initialValues);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <section className="w-full flex justify-center">
            <div className="max-w-[var(--max-page-width)] w-full px-[var(--container-padding)] my-4 sm:my-8 md:my-14 lg:my-20">

                {/* <h1 className="font-extrabold text-[clamp(20px,3vw,42px)] text-black leading-normal mb-2">
                    Grievance Redressal
                </h1>

                <div className="w-full flex justify-start bg-white mb-4">
                    <p className="text-xl">
                        <span className="font-semibold text-xl">*</span> Students can also email{" "}
                        <Link
                            href="mailto:grievances@msu.edu.in"
                            className="text-[#FFA201] underline"
                        >
                            grievances@msu.edu.in
                        </Link>{" "} for any further help.
                    </p>
                </div> */}

                {/* <form onSubmit={handleSubmit} className="w-full max-w-5xl">

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <FormInput name="fullName" value={values.fullName} onChange={handleChange} placeholder="Full Name *" error={errors.fullName} />
                        <FormInput name="email" value={values.email} onChange={handleChange} placeholder="Email *" error={errors.email} />

                        <div>
                            <select
                                name="gender"
                                value={values.gender}
                                onChange={handleChange}
                                className="w-full border border-black/60 rounded-none px-4 py-3 bg-white outline-none focus:border-black"
                            >
                                <option value="">Gender *</option>
                                {["Male", "Female", "Other"].map((g) => (
                                    <option key={g} value={g.toLowerCase()}>{g}</option>
                                ))}
                            </select>
                            {errors.gender && (
                                <p className="mt-1 text-xs text-red-600">{errors.gender}</p>
                            )}
                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <FormInput name="mobile" value={values.mobile} onChange={handleChange} placeholder="Mobile Number *" error={errors.mobile} />
                        <FormInput name="registration" value={values.registration} onChange={handleChange} placeholder="Registration Number *" error={errors.registration} />
                    </div>

                    <FormInput name="programme" value={values.programme} onChange={handleChange} placeholder="Programme *" error={errors.programme} />

                    <div className="mb-4">
                        <select
                            name="category"
                            value={values.category}
                            onChange={handleChange}
                            className="w-full border border-black/60 rounded-none px-4 py-3 bg-white outline-none focus:border-black"
                        >
                            <option value="" disabled >
                                Grievance Category *
                            </option>

                            {grievanceCategories.map((c, idx) => (
                                <option key={idx} value={c.toLowerCase().replace(/\s+/g, "-")}>
                                    {c}
                                </option>
                            ))}
                        </select>

                    </div>

                    <div className="mb-4 md:mb-5">
                        <textarea
                            name="message"
                            value={values.message}
                            onChange={handleChange}
                            placeholder="Your message"
                            rows={6}
                            className="w-full border border-black/60 rounded-none px-4 py-3 outline-none resize-none focus:border-black"
                        />
                        {errors.message && (
                            <p className="mt-1 text-xs text-red-600">{errors.message}</p>
                        )}
                    </div>

                    <div className="flex justify-center">
                        <button
                            type="submit"
                            disabled={submitting}
                            className={`cursor-pointer w-full md:w-auto px-10 py-3 bg-[#FFA201] text-white font-semibold tracking-wide text-lg 
                                rounded-none hover:bg-[#ffb01f] disabled:opacity-60 disabled:cursor-not-allowed transition-colors`}
                        >
                            {submitting ? "Submitting..." : "SUBMIT"}
                        </button>
                    </div>

                </form> */}


                <div className="w-full flex justify-left px-4 py-10">
                    <div className="w-full max-w-lg bg-white border border-gray-200 rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.07)] p-6 flex items-center gap-6">

                        <div className="w-32 h-32 flex items-center justify-center bg-white border border-gray-100 rounded-xl shadow-sm">
                            <img
                                src="https://cdn.msu.edu.in/logos/UGC.webp"
                                alt="UGC Logo"
                                className="w-full h-full object-contain p-3"
                            />
                        </div>

                        <div className="flex flex-col gap-3">
                            <h3 className="text-xl font-semibold text-[#0A0A0A] leading-snug">
                                Student Grievance <br /> Redressal Committee
                            </h3>

                            <div className="flex items-center gap-3">
                                <span className="text-[#E09512] font-semibold tracking-wide text-sm">
                                    VIEW PDF
                                </span>

                                <Link href="https://cdn.msu.edu.in/SGRC_RO_f67407a95f.pdf" target='_blank' 
                                className="cursor-pointer w-8 h-8 flex items-center justify-center bg-[#002B45] rounded-full">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-4 h-4 text-white"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                    </svg>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    );
};
